import {NgModule} from '@angular/core';
import {NcDatatableComponent} from './nc-datatable/nc-datatable.component';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {NcFilterDispatcherComponent} from './nc-filter-dispatcher/nc-filter-dispatcher.component';
import {NcCellDispatcherComponent} from './nc-cell-dispatcher/nc-cell-dispatcher.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NcSharedModule} from 'nc-shared';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MAT_DATE_FORMATS, MatCommonModule, MatNativeDateModule} from '@angular/material/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';
import {NcActionCellComponent} from './nc-cells/nc-action-cell/nc-action-cell.component';
import {NcSelectCellComponent} from './nc-cells/nc-select-cell/nc-select-cell.component';
import {PaginatorI18n} from './utils/paginator-i18n';
import {NcCheckboxCellComponent} from './nc-cells/nc-checkbox-cell/nc-checkbox-cell.component';
import {FlexModule} from '@angular/flex-layout';
import {NcSelectFilterComponent} from './nc-filter/nc-select-filter/nc-select-filter.component';
import {NcDateFilterComponent} from './nc-filter/nc-date-filter/nc-date-filter.component';
import {NcTextFilterComponent} from './nc-filter/nc-text-filter/nc-text-filter.component';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {DateFormats} from 'nc-utils';
import {NcCheckboxCellHeaderComponent} from './nc-cells/nc-checkbox-cell-header/nc-checkbox-cell-header.component';

@NgModule({
  declarations: [
    NcDatatableComponent,
    NcFilterDispatcherComponent,
    NcCellDispatcherComponent,
    NcActionCellComponent,
    NcSelectCellComponent,
    NcCheckboxCellComponent,
    NcSelectFilterComponent,
    NcDateFilterComponent,
    NcTextFilterComponent,
    NcCheckboxCellHeaderComponent
  ],
  imports: [
    MatCommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    DragDropModule,
    NcSharedModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    TranslateModule,
    MatMomentDateModule,
    MatIconModule,
    FlexModule,
  ],
  exports: [
    NcDatatableComponent
  ],
  providers: [
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    },
    {provide: MAT_DATE_FORMATS, useValue: DateFormats}
  ]
})
export class NcDatatableModule {
}
